import ptPT from './onboardingTranslations/pt-PT';

export const ONBOARDING_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'pt-PT', label: 'PT-PT' }
];

const EN_TRANSLATIONS = {
  locale: 'en-GB',
  stages: {
    contract: { title: 'Contract review + 50% Deposit', owner: 'Client + GuideSofia' },
    kickoff: { title: 'Kickoff Meeting', owner: 'Client + GuideSofia' },
    routeMaterials: { title: 'Route / Stops + Materials', owner: 'Client' },
    draft: { title: 'First version of the script', owner: 'GuideSofia' },
    midwork: { title: 'Mid-project Check-in', owner: 'Client + GuideSofia' },
    review: { title: 'Client Review', owner: 'Client' },
    translations: { title: 'Translations + Voice Overs', owner: 'GuideSofia' },
    qa: { title: 'Quality control (Humano)', owner: 'GuideSofia' },
    launch: { title: 'Launch Communication', owner: 'Client + GuideSofia' }
  },
  materials: {
    institution: 'Institution / project name',
    contact: 'Main contact person',
    objective: 'Project objective',
    texts: 'Texts / docs / PDFs',
    media: 'Photos / audio / media',
    venue: 'Venue / project context',
    route: 'Stops list / route indication',
    gps: 'GPS points',
    brand: 'Brand guidelines / logo',
    accessibility: 'Accessibility needs',
    launchDate: 'Launch date or ideal timeline'
  },
  payments: {
    contractStage: 'Contract review',
    paymentStage: '50% Deposit',
    contractPaymentStage: 'Contract review + 50% Deposit',
    contractReviewed: 'Contract reviewed',
    contractSigned: 'Contract signed',
    depositPaid: '50% deposit paid at signing',
    finalPaid: 'Final 50% paid at guide delivery'
  },
  statuses: {
    todo: 'To do',
    active: 'Active',
    blocked: 'Waiting action',
    done: 'Done'
  },
  projectTypes: {
    museum: 'Museum Guide',
    municipality: 'Municipality / Destination',
    temporary: 'Temporary Exhibition',
    pilot: 'Pilot Project',
    virtual: 'Virtual Tour / 360'
  },
  tabs: {
    timeline: 'Timeline',
    production: 'Production',
    'project-details': 'Project details',
    materials: 'Materials',
    languages: 'Languages',
    review: 'Review',
    launch: 'Launch',
    'add-ons': 'Optional add-ons',
    'launch-assets': 'Launch assets',
    'qr-codes': 'QR Codes',
    'media-press': 'Media Package',
    'launch-plan': 'Launch plan',
    'launch-training': 'Training',
    documents: 'Documents',
    payments: 'Payments',
    scope: 'Scope & changes',
    contact: 'Contact',
    roles: 'Roles',
    faq: 'FAQ'
  },
  launchItems: {
    contentApproved: 'Content approved',
    translationsApproved: 'Translations approved',
    audioChecked: 'Audio checked',
    qrTested: 'QR codes tested',
    qrPlaced: 'Physical QR codes placed',
    teamInformed: 'Reception / visitor team informed',
    websiteReady: 'Website or social post prepared',
    analyticsActive: 'Analytics activated',
    launchConfirmed: 'Launch date confirmed'
  },
  launchAssets: {
    qrCodeLinks: 'QR code links',
    promoMaterialsLinks: 'Promotion materials links'
  },
  addOns: {
    'venue-pages': {
      label: 'Venue pages',
      description: 'Dedicated venue or exhibition landing pages connected to the guide.'
    },
    'qr-rollout': {
      label: 'QR rollout',
      description: 'Extra support for QR implementation, placement planning and rollout.'
    },
    translations: {
      label: 'Extra languages',
      description: 'Additional translations and voice overs beyond the base scope.'
    },
    'virtual-360': {
      label: 'Virtual 360 visit',
      description: 'A 360-degree virtual experience for remote or hybrid visits.'
    },
    'augmented-reality': {
      label: 'Augmented reality',
      description: 'AR moments that add digital layers to the visitor experience.'
    },
    gamification: {
      label: 'Gamification',
      description: 'Quizzes, challenges or playful interactions for visitors.'
    },
    'sign-language-pt': {
      label: 'Portuguese sign language',
      description: 'Accessibility support with Portuguese sign language content.'
    },
    'collection-catalog': {
      label: 'Collection catalog',
      description: 'A digital catalog for the collection or exhibition highlights.'
    },
    surveys: {
      label: 'Surveys',
      description: 'Visitor surveys or feedback forms connected to the project.'
    },
    'advanced-content': {
      label: 'Advanced content',
      description: 'Richer storytelling, special features or expanded content modules.'
    }
  },
  mediaPress: {
    mediaKitUrl: 'Media kit link',
    pressReleaseUrl: 'Press release link',
    pressCoverageLinks: 'Press coverage links'
  },
  reviewItems: {
    clientGuideText: 'Guide text reviewed',
    qaTexts: 'Texts quality control (Humano)',
    qaQrCodes: 'QR codes quality control (Humano)',
    qaAudios: 'Audio quality control (Humano)'
  },
  qrPlacements: {
    reception: 'Reception / ticket office',
    routeStart: 'Start of route',
    stops: 'Each room, stop or object area',
    printed: 'Printed maps / brochures',
    website: 'Website',
    social: 'Social media / newsletter'
  },
  guideSofiaResponsibilities: [
    'Structure the digital guide',
    'Create or adapt scripts',
    'Prepare translations when included',
    'Generate QR codes and guide links',
    'Publish the visitor experience',
    'Provide analytics and technical support'
  ],
  clientResponsibilities: [
    'Share official materials',
    'Validate historical and factual accuracy',
    'Approve final content',
    'Place QR codes on-site',
    'Promote the guide to visitors',
    'Inform front-desk or visitor-facing teams'
  ],
  faq: [
    {
      question: 'How long does implementation take?',
      answer: 'It depends on the number of stops, languages, review cycles and content complexity. The timeline above shows the current working estimate.'
    },
    {
      question: 'Do we need to have all content ready?',
      answer: 'No. GuideSofia can work from existing materials, or help adapt content into visitor-friendly storytelling.'
    },
    {
      question: 'Who validates historical accuracy?',
      answer: 'The client validates factual and institutional accuracy before the guide is approved for production and launch.'
    },
    {
      question: 'Can the guide be updated later?',
      answer: 'Yes, updates can be planned after launch depending on the package and operational needs.'
    },
    {
      question: 'Can we see visitor data?',
      answer: 'Yes. Analytics can show access volume, languages used, popular stops and opportunities to improve the visitor experience.'
    }
  ],
  copy: {
    loading: 'Loading onboarding page...',
    unavailable: 'This onboarding page is not available.',
    passwordPrompt: 'Enter the password provided by GuideSofia.',
    incorrectPassword: 'Incorrect password.',
    viewOnboarding: 'View onboarding',
    onboardingLabel: 'GuideSofia Onboarding',
    pageSummary: 'requested items',
    received: 'received',
    noActivePhase: 'No active phase',
    hubTitle: 'Client Onboarding Hub',
    hubIntro: 'What happens now, what do we need from you, and how do we make this launch easy?',
    hubDescription: 'This page keeps the project clear after approval: timeline, material requests, review status, launch readiness, QR rollout and responsibilities.',
    openHubButton: 'Open project hub',
    requestedItems: 'Requested items',
    launchReady: 'Launch ready',
    guideQrTitle: 'Guide QR code',
    guideQrHelp: 'The QR image the client will scan to open the guide directly.',
    uploadGuideQr: 'Upload QR image',
    openGuideQr: 'Open QR image',
    guideQrReady: 'QR image uploaded',
    guideQrMissing: 'No QR image uploaded yet.',
    launchDates: 'Launch dates',
    estimatedLaunchDate: 'Estimated launch date',
    agreedLaunchDate: 'Agreed launch date',
    welcomeTitle: 'Welcome to GuideSofia',
    welcomeBody: 'We are excited to help you create a multilingual, accessible and data-driven visitor experience for your museum, municipality, route or destination.',
    welcomeSupporting: 'On this page, you will find the project steps, required materials, timeline, responsibilities and useful links.',
    buildTitle: 'What we will build together',
    buildBody: 'GuideSofia helps visitors explore cultural places on their own phone through QR codes, audio storytelling, maps, multilingual content, accessibility features and visitor analytics.',
    buildListTitle: 'Your project may include',
    buildList: [
      'Audio guide stops',
      'QR codes',
      'Interactive map',
      'Multilingual content',
      'Accessibility adaptations',
      'Visitor analytics'
    ],
    accessibilityTitle: 'Accessibility and inclusion',
    accessibilityBody: 'GuideSofia is designed to make cultural experiences more accessible, including for blind and visually impaired visitors, deaf visitors, international audiences and people who prefer self-guided experiences.',
    accessibilityPoints: [
      'Multilingual access',
      'Audio-first experience',
      'Text support',
      'Sign language video integration',
      'Prepared for blind users and screen-reader-friendly use',
      'Inclusive BYOD model'
    ],
    analyticsTitle: 'Analytics and impact',
    analyticsBody: 'After launch, GuideSofia can help you understand how visitors use the experience and where to improve it.',
    analyticsButton: 'Analytics details',
    languageLabel: 'Language',
    projectTimeline: 'Project Timeline',
    projectTypeNotSet: 'Project type not set',
    noStages: 'No stages',
    workingDays: 'working days',
    complete: 'complete',
    to: 'to',
    guideSofiaLegend: 'GuideSofia',
    clientLegend: 'Client',
    sharedLegend: 'Shared',
    weekendLegend: 'Weekend',
    today: 'Today',
    ganttChart: 'Gantt chart',
    whatWeNeed: 'What We Need',
    pending: 'Pending',
    noMaterialRequests: 'No material requests selected yet.',
    uploadDrive: 'Upload files to GuideSofia Drive',
    contractPayment: 'Contract + Payment',
    contractOnly: 'Contract',
    paymentOnly: 'Payment',
    contractPaymentHelp: '50% at signing, 50% at guide delivery.',
    contractOnlyHelp: 'Contract review and signature.',
    paymentOnlyHelp: 'Payment status for this project.',
    reviewDocument: 'Review document',
    reviewDocumentHelp: 'Use this document for guide text review and comments. You can suggest wording changes, add or remove stops, or change the order, then leave comments in Google Docs so we can revise it later.',
    openReviewDoc: 'Open review doc',
    reviewDocMissing: 'Review document not set yet.',
    reviewChecklist: 'Review checklist',
    clientReview: 'Client review',
    guidesofiaQa: 'Quality control (Humano)',
    guidesofiaQaDescription: 'GuideSofia checks the content, QR codes and audio before launch.',
    reviewTextReviewedLabel: 'Client text reviewed: approved for production',
    reviewTextReviewedPendingStatus: 'Waiting for client confirmation',
    reviewTextReviewedApprovedStatus: 'Approved for production',
    reviewTextReviewedConfirmTitle: 'Confirm review',
    reviewTextReviewedConfirmBody: 'Confirm that you have reviewed the text and consider it suitable for production. The GuideSofia team will be notified.',
    reviewTextReviewedConfirmAction: 'Confirm',
    reviewTextReviewedCancelAction: 'Cancel',
    launchChecklist: 'Launch checklist',
    launchChecklistHelp: 'Items that should be ready before going live.',
    qrImplementation: 'QR implementation',
    qrImplementationHelp: 'Selected placements for this launch.',
    noQrPlacements: 'No QR placements selected yet.',
    qrCallToAction: 'Use short, action-led lines that tell visitors what they get immediately, such as "Scan to start the audioguide", "Open the route in your language" or "Discover this stop in under a minute".',
    launchAssetsTitle: 'Launch assets',
    launchAssetsHelp: 'Links for QR codes and promotion materials.',
    noLinksAdded: 'No links added.',
    launchAssetsSummary: 'Summary',
    launchAssetsEmpty: 'Launch asset links will appear here once added.',
    mediaPressTitle: 'Media / press',
    mediaPressHelp: 'Access the media kit, press release and related launch coverage from one place.',
    mediaPressEmpty: 'Media and press links will appear here once added.',
    mediaPressNotesTitle: 'Messaging notes',
    mediaPressNotesEmpty: 'No messaging notes added yet.',
    paymentsTitle: 'Payments',
    paymentsHelp: 'Bank details and payment status for this project.',
    paymentStatus: 'Payment status',
    paymentComplete: 'Payment complete',
    paymentCompleteYes: 'Yes, payment is complete',
    paymentCompleteNo: 'No, payment is still open',
    paymentNotes: 'Notes',
    documentsTitle: 'Documents',
    documentsHelp: 'Shared documents for this project, such as contracts and supporting files.',
    openDocumentsLink: 'Open documents folder',
    documentsMissing: 'Documents link not set yet.',
    contactTitle: 'GuideSofia project contact',
    contactHelp: 'Your main contact for questions, approvals and day-to-day coordination.',
    clientContactTitle: 'Client project contact',
    clientContactHelp: 'Main contact person on the client side for approvals and coordination.',
    projectManager: 'Project manager',
    contactName: 'Contact name',
    email: 'Email',
    whatsapp: 'Telephone / WhatsApp',
    notSetYet: 'Not set yet',
    meetingTitle: 'Book a meeting',
    meetingHelp: 'Need help with something? Book a call with the GuideSofia team for support.',
    openBookingLink: 'Open booking link',
    bookingMissing: 'Booking link not set yet.',
    gsResponsibilities: 'GuideSofia responsibilities',
    clientResponsibilities: 'Client responsibilities',
    faqTitle: 'FAQ'
  }
};

const EXTRA_ADD_ON_TRANSLATIONS = {
  en: {
    tabs: {
      'add-ons': 'Optional add-ons'
    },
    addOns: {
      'venue-pages': {
        label: 'Venue pages',
        description: 'Dedicated venue or exhibition landing pages connected to the guide.'
      },
      'qr-rollout': {
        label: 'QR rollout',
        description: 'Extra support for QR implementation, placement planning and rollout.'
      },
      translations: {
        label: 'Extra languages',
        description: 'Additional translations and voice overs beyond the base scope.'
      },
      'advanced-content': {
        label: 'Advanced content',
        description: 'Richer storytelling, special features or expanded content modules.'
      }
    },
    copy: {
      addOnsTitle: 'Optional add-ons',
      addOnsHelp: 'Extra services you can choose to expand the project.',
      addOnsEmpty: 'No optional add-ons are being highlighted for this project yet.',
      addOnsNextTitle: 'Interested in any of these?',
      addOnsNextHelp: 'If one of these add-ons is relevant, let us know and we can include it in the next step of the project.',
      addOnsNextBody: 'You can raise this in the next review round or book a meeting with the GuideSofia team to discuss scope, timing and pricing.',
      additionalContactLabel: 'Additional contact'
    }
  }
};

const EXTRA_LANGUAGE_TRANSLATIONS = {
  en: {
    tabs: {
      languages: 'Languages'
    },
    guideLanguages: {
      'pt-PT': 'Portuguese (PT-PT)',
      en: 'English',
      es: 'Spanish',
      fr: 'French',
      de: 'German',
      it: 'Italian',
      nl: 'Dutch',
      ru: 'Russian',
      ar: 'Arabic',
      zh: 'Chinese',
      ja: 'Japanese'
    },
    copy: {
      languagesTitle: 'Languages',
      languagesHelp: 'See which guide languages are selected and which ones are ready.',
      languagesSummaryTitle: 'All languages',
      languagesSummaryHelp: 'Selected languages and their status.',
      selected: 'Selected',
      ready: 'Ready',
      inProgress: 'In progress',
      notSelected: 'Not selected',
      noLanguagesSelected: 'No guide languages selected yet.',
      baseLanguage: 'Base language',
      additionalLanguage: 'Additional language'
    }
  }
};

const buildEnglishTranslations = () => ({
  ...EN_TRANSLATIONS,
  tabs: {
    ...(EN_TRANSLATIONS.tabs || {}),
    ...(EXTRA_ADD_ON_TRANSLATIONS.en.tabs || {}),
    ...(EXTRA_LANGUAGE_TRANSLATIONS.en.tabs || {})
  },
  addOns: {
    ...(EN_TRANSLATIONS.addOns || {}),
    ...(EXTRA_ADD_ON_TRANSLATIONS.en.addOns || {})
  },
  guideLanguages: {
    ...(EXTRA_LANGUAGE_TRANSLATIONS.en.guideLanguages || {})
  },
  copy: {
    ...(EN_TRANSLATIONS.copy || {}),
    ...(EXTRA_ADD_ON_TRANSLATIONS.en.copy || {}),
    ...(EXTRA_LANGUAGE_TRANSLATIONS.en.copy || {})
  }
});

export const getOnboardingTranslations = (language) => {
  if (language === 'pt-PT') {
    return ptPT;
  }

  return buildEnglishTranslations();
};
